// import { Modal, Timeline, Tag } from "antd";
// import { useEffect, useState } from "react";
// import { getHistorique } from "../../api/prospections";

// const actionLabel = {
//   CREATION: "Création",
//   CHANGEMENT_STATUS: "Changement de statut",
//   RELANCE_CREE: "Relance créée",
//   RELANCE_EFFECTUEE: "Relance effectuée",
// };

// export default function ModalHistorique({ open, onClose, prospection }) {
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     if (open && prospection) {
//       loadHistorique();
//     }
//   }, [open, prospection]);

//   const loadHistorique = async () => {
//     const res = await getHistorique(prospection.id);
//     setData(res.data);
//   };

//   return (
//     <Modal
//       title={`Historique – ${prospection?.objet || ""}`}
//       open={open}
//       onCancel={onClose}
//       footer={null}
//       width={600}
//     >
//       <Timeline mode="left">
//         {data.map((item) => (
//           <Timeline.Item key={item.id}>
//             <div>
//               <strong>{actionLabel[item.action]}</strong>
//             </div>

//             {item.ancien_status && (
//               <div>
//                 <Tag>{item.ancien_status}</Tag> →{" "}
//                 <Tag color="green">{item.nouveau_status}</Tag>
//               </div>
//             )}

//             {item.commentaire && (
//               <div style={{ marginTop: 5 }}>
//                 <em>{item.commentaire}</em>
//               </div>
//             )}

//             <div style={{ fontSize: 12, color: "#999" }}>
//               {new Date(item.created_at).toLocaleString()}
//             </div>
//           </Timeline.Item>
//         ))}
//       </Timeline>
//     </Modal>
//   );
// }
import { Modal, Timeline, Tag } from "antd";
import {
  PlusCircleOutlined,
  SyncOutlined,
  BellOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { getHistorique } from "../../api/prospections";

const actionConfig = {
  CREATION: {
    label: "Prospection créée",
    icon: <PlusCircleOutlined />,
    color: "blue",
  },
  CHANGEMENT_STATUS: {
    label: "Changement de statut",
    icon: <SyncOutlined />,
    color: "green",
  },
  RELANCE_CREE: {
    label: "Relance planifiée",
    icon: <BellOutlined />,
    color: "orange",
  },
  RELANCE_EFFECTUEE: {
    label: "Relance effectuée",
    icon: <CheckCircleOutlined />,
    color: "purple",
  },
};

export default function ModalHistorique({ open, onClose, prospection, liste_users }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (open && prospection) {
      loadHistorique();
    }
  }, [open, prospection]);

  const loadHistorique = async () => {
    const res = await getHistorique(prospection.id);
    setData(res.data);
  };

  return (
    <Modal
      title={`Historique de la prospection`}
      open={open}
      onCancel={onClose}
      footer={null}
      width={650}
      style={{height: "60vh"}}
    >
      <Timeline
        style={{
          height: "60vh",
          overflowY: "auto",
          top:5
        }}
      >
        {data.map((item) => {
          const config = actionConfig[item.action] || {};

          return (
            <Timeline.Item
              key={item.id}
              dot={config.icon}
              color={config.color}
            >
              <div style={{ marginBottom: 4 }}>
                <strong>{config.label}</strong>
              </div>

              {item.ancien_status && (
                <div style={{ marginBottom: 4 }}>
                  Statut :
                  <Tag style={{ marginLeft: 8 }}>
                    {item.ancien_status}
                  </Tag>
                  →
                  <Tag color="green" style={{ marginLeft: 8 }}>
                    {item.nouveau_status}
                  </Tag>
                  →
                  <Tag color="purple" style={{ marginLeft: 8 }}>
                    Fait par {
                      liste_users.find((u) => u.id === item.user_id)?.prenom || "Inconnu"
                    }
                  </Tag>
                </div>
              )}

              {item.commentaire && (
                <div
                  style={{
                    background: "#fafafa",
                    padding: "6px 10px",
                    borderLeft: "3px solid #ddd",
                    marginTop: 6,
                  }}
                >
                  💬 {item.commentaire}  →
                  <Tag color="blue" style={{ marginLeft: 8 }}>
                    Fait par {
                      liste_users.find((u) => u.id === item.user_id)?.prenom || "Inconnu"
                    }
                  </Tag>
                </div>
              )}

              <div style={{ fontSize: 12, color: "#999", marginTop: 6 }}>
                {new Date(item.created_at).toLocaleString()}
              </div>
            </Timeline.Item>
          );
        })}
      </Timeline>
    </Modal>
  );
}
